export const inlineTags = ['ul', 'ol', 'div'];
//# sourceMappingURL=types.js.map